import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import styles from "../pages/Styles.module.css"; 
import modalStyles from "./Modals/Modal.module.css";

// ÍCONES
import { 
    LogOut, Globe, Settings, Key, UserCircle,
    ChevronDown, ChevronRight, FileText, Home, 
    Briefcase 
} from "lucide-react";
import { LiaUniversitySolid } from "react-icons/lia";

import axiosInstance from "../services/axiosInstance";
import { getSessionId, getTabId, logout as doLogout } from "../utils/auth";
import { usePainelSocket, useSessionSocket } from "../pages/contexts/SocketContext";
import { mapToCanonicalRole } from "../utils/roleMap";
import ModalAlterarSenha from "./Modals/ModalAlterarSenha";

function ConfirmLogoutModal({ open, onConfirm, onCancel }) {
    if (!open) return null;
    return (
        <div className={modalStyles.modalOverlay} style={{zIndex: 9999}}>
            <div className={modalStyles.modalMenu}>
                <div className={modalStyles.modalHeader}><h2 className={modalStyles.modalTitle}>Confirmar saída</h2></div>
                <div className={modalStyles.modalBody}><p>Deseja realmente sair do sistema?</p></div>
                <div className={modalStyles.modalFooter} style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
                    <button className={modalStyles.btnStop} onClick={onCancel}>Cancelar</button>
                    <button className={modalStyles.encerrarVotacao} onClick={onConfirm}>Sair</button>
                </div>
            </div>
        </div>
    );
}

const DockMenu = ({ fotoUrl, onLogout }) => {
    const dropdownRef = useRef(null);
    const [showMenu, setShowMenu] = useState(false);
    const [showLogoutModal, setShowLogoutModal] = useState(false);
    const [abrirModalSenha, setAbrirModalSenha] = useState(false);
    
    // Controle dos submenus expansíveis
    const [menuAberto, setMenuAberto] = useState(null);

    const painelSocket = usePainelSocket();
    const sessionSocket = useSessionSocket();

    const cargoUsuario = localStorage.getItem("role") || "vereador";
    const roleCanonical = mapToCanonicalRole(cargoUsuario);
    const isAdmin = ['admin', 'root', 'presidente', 'secretario', 'servidor'].includes(roleCanonical);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowMenu(false);
                setMenuAberto(null); // Reseta os submenus ao clicar fora
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const realizarLogout = async () => {
        try { await axiosInstance.post("/auth/logout", { sessionId: getSessionId(), tabId: getTabId() }); } catch (e) { console.warn(e); } 
        finally {
            try { sessionSocket?.disconnect(); painelSocket?.disconnect(); } catch {}
            doLogout();
            if(onLogout) onLogout();
            window.location.replace("/login");
        }
    };

    const toggleSubMenu = (menu) => {
        setMenuAberto(menuAberto === menu ? null : menu);
    };

    // Estilos extraídos
    const navLink = {
        display: 'flex', alignItems: 'center', gap: 10, padding: '12px 16px', 
        border: 'none', background: 'transparent', width: '100%', 
        textAlign: 'left', cursor: 'pointer', color: '#333', justifyContent: "space-between",
        textDecoration: 'none'
    };
    
    const subNavLink = {
        ...navLink,
        padding: '10px 16px 10px 42px', // Recuo para o submenu
        color: '#555',
        textDecoration: 'none'
    };

    return (
        <div style={{ position: 'relative' }} ref={dropdownRef}>
            <button 
                onClick={() => setShowMenu(!showMenu)}
                style={{ 
                    width: 38, height: 38, minWidth: 38, borderRadius: '50%', overflow: 'hidden', 
                    border: '2px solid rgba(255,255,255,0.8)', boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
                    cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center',
                    backgroundColor: '#eee', padding: 0
                }}
                title="Menu Principal"
            >
                {fotoUrl ? (
                    <img src={fotoUrl} alt="Perfil" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                ) : (
                    <UserCircle size={32} color="#888" />
                )}
            </button>

            {showMenu && (
                <div className={styles.menuDropdown} style={{
                    position: 'absolute', top: '120%', right: 0, width: '260px',
                    backgroundColor: '#fff', boxShadow: '0 5px 20px rgba(0,0,0,0.2)',
                    borderRadius: '8px', padding: '5px 0', zIndex: 1000,
                    display: 'flex', flexDirection: 'column', border: '1px solid #eee'
                }}>
                    
                    <Link to="/plenario" Xrel="noopener noreferrer" className={styles.navLink} onClick={() => setShowMenu(false)} style={{textDecoration: 'none'}}>
                        <LiaUniversitySolid size={22} color="#336699" /> Plenário Virtual
                    </Link>

                    {isAdmin && (
                        <>
                            <div style={{ height: 1, backgroundColor: '#eee', margin: '4px 0' }}></div>
                            
                            {/* Sessões */}
                            <button onClick={() => toggleSubMenu('sessoes')} style={navLink} className={styles.menuItemHover}>
                                <div style={{display: 'flex', alignItems: 'center', gap: 10}}><Home size={20} color="#e74c3c" /> Sessões</div>
                                {menuAberto === 'sessoes' ? <ChevronDown size={16}/> : <ChevronRight size={16}/>}
                            </button>
                            {menuAberto === 'sessoes' && (
                                <div style={{display: 'flex', flexDirection: 'column'}}>
                                    <Link to="/config-camara?tab=sessoes" Xrel="noopener noreferrer" onClick={() => setShowMenu(false)} style={subNavLink} className={styles.menuItemHover}>Sessões Plenárias</Link>
                                    <Link to="/config-camara?tab=painelcontrole" Xrel="noopener noreferrer" onClick={() => setShowMenu(false)} style={subNavLink} className={styles.menuItemHover}>Painel de Controle</Link>
                                    <Link to="/config-camara?tab=atas" Xrel="noopener noreferrer" onClick={() => setShowMenu(false)} style={subNavLink} className={styles.menuItemHover}>Atas</Link>
                                    <Link to="/config-camara?tab=votacoes" Xrel="noopener noreferrer" onClick={() => setShowMenu(false)} style={subNavLink} className={styles.menuItemHover}>Votações</Link>
                                </div>
                            )}

                            {/* Matérias */}
                            <button onClick={() => toggleSubMenu('materias')} style={navLink} className={styles.menuItemHover}>
                                <div style={{display: 'flex', alignItems: 'center', gap: 10}}><FileText size={20} color="#d35400" /> Matérias</div>
                                {menuAberto === 'materias' ? <ChevronDown size={16}/> : <ChevronRight size={16}/>}
                            </button>
                            {menuAberto === 'materias' && (
                                <div style={{display: 'flex', flexDirection: 'column'}}>
                                    <Link to="/config-camara?tab=pautas" Xrel="noopener noreferrer" onClick={() => setShowMenu(false)} style={subNavLink} className={styles.menuItemHover}>Matérias Legislativas</Link>
                                    <Link to="/config-camara?tab=documentos" Xrel="noopener noreferrer" onClick={() => setShowMenu(false)} style={subNavLink} className={styles.menuItemHover}>Modelos e Documentos</Link>
                                </div>
                            )}

                            {/* Legislaturas */}
                            <button onClick={() => toggleSubMenu('legislaturas')} style={navLink} className={styles.menuItemHover}>
                                <div style={{display: 'flex', alignItems: 'center', gap: 10}}><Briefcase size={20} color="#9b59b6" /> Legislaturas</div>
                                {menuAberto === 'legislaturas' ? <ChevronDown size={16}/> : <ChevronRight size={16}/>}
                            </button>
                            {menuAberto === 'legislaturas' && (
                                <div style={{display: 'flex', flexDirection: 'column'}}>
                                    <Link to="/config-camara?tab=legislativo" Xrel="noopener noreferrer" onClick={() => setShowMenu(false)} style={subNavLink} className={styles.menuItemHover}>Legislaturas</Link>
                                    <Link to="/config-camara?tab=comissoes" Xrel="noopener noreferrer" onClick={() => setShowMenu(false)} style={subNavLink} className={styles.menuItemHover}>Comissões</Link>
                                    <Link to="/config-camara?tab=noticias" Xrel="noopener noreferrer" onClick={() => setShowMenu(false)} style={subNavLink} className={styles.menuItemHover}>Publicações (Notícias)</Link>
                                </div>
                            )}

                            {/* Configurações */}
                            <button onClick={() => toggleSubMenu('configuracoes')} style={navLink} className={styles.menuItemHover}>
                                <div style={{display: 'flex', alignItems: 'center', gap: 10}}><Settings size={20} color="#555" /> Configurações</div>
                                {menuAberto === 'configuracoes' ? <ChevronDown size={16}/> : <ChevronRight size={16}/>}
                            </button>
                            {menuAberto === 'configuracoes' && (
                                <div style={{display: 'flex', flexDirection: 'column'}}>
                                    <Link to="/config-camara?tab=dados_camara" Xrel="noopener noreferrer" onClick={() => setShowMenu(false)} style={subNavLink} className={styles.menuItemHover}>Perfil da Câmara</Link>
                                    <Link to="/config-camara?tab=usuarios" Xrel="noopener noreferrer" onClick={() => setShowMenu(false)} style={subNavLink} className={styles.menuItemHover}>Gestão de Usuários</Link>
                                    <Link to="/config-camara?tab=fluxo" Xrel="noopener noreferrer" onClick={() => setShowMenu(false)} style={subNavLink} className={styles.menuItemHover}>Rito e Tramitação</Link>
                                    <Link to="/config-camara?tab=relatorios" Xrel="noopener noreferrer" onClick={() => setShowMenu(false)} style={subNavLink} className={styles.menuItemHover}>Relatórios</Link>
                                    <Link to="/config-camara?tab=backups" Xrel="noopener noreferrer" onClick={() => setShowMenu(false)} style={subNavLink} className={styles.menuItemHover}>Backups</Link>
                                </div>
                            )}
                        </>
                    )}

                    <div style={{ height: 1, backgroundColor: '#eee', margin: '4px 0' }}></div>

                    <button onClick={() => { setShowMenu(false); setAbrirModalSenha(true); }} style={navLink} className={styles.menuItemHover}>
                        <div style={{display: 'flex', alignItems: 'center', gap: 10}}><Key size={20} color="#555" /> Alterar Senha</div>
                    </button>

                    <button onClick={() => { window.open('/portal', '_blank'); setShowMenu(false); }} style={navLink} className={styles.navLink}>
                        <div style={{display: 'flex', alignItems: 'center', gap: 10}}><Globe size={20} color="#27ae60"/> Portal Público</div>
                    </button>

                    <button 
                        onClick={() => { setShowMenu(false); setShowLogoutModal(true); }}
                        style={{ ...navLink, color: '#c62828' }}
                        className={styles.menuItemHover}
                    >
                        <div style={{display: 'flex', alignItems: 'center', gap: 10}}><LogOut size={20} /> Sair</div>
                    </button>
                </div>
            )}

            {abrirModalSenha && (
                <ModalAlterarSenha show onClose={() => setAbrirModalSenha(false)} />
            )}
            <ConfirmLogoutModal open={showLogoutModal} onConfirm={realizarLogout} onCancel={() => setShowLogoutModal(false)} />
        </div>
    );
};

export default DockMenu;